import { LangInstanceConfig } from "@core/interface/environment.interface"

interface LangInstanceConfigs {
    [langInstance: string]: LangInstanceConfig
}

const SkVersionDefaults: LangInstanceConfig =  {
    languages: [
        {
            "name": "Slovenčina",
            "code": "SK",
            "iso": "sk-SK"
        },
        {
            "name": "English",
            "code": "EN",
            "iso": "en-US"
        }
    ],
    currency: 'EUR',
    phonePrefix: '+421',
    phoneValidationHint: '+421 910 123 456',
    infoline: "+421 2 50 122 222",
    googleMapsOptions: {
        center: {
            lat: 48.7798634,
            lng: 19.7603539,
        },
        zoom: 8
    },
}

const CzVersionDefaults: LangInstanceConfig =  {
    languages: [
        {
            "name": "Čeština",
            "code": "CS",
            "iso": "cs-CS"
        },
        {
            "name": "English",
            "code": "EN",
            "iso": "en-US"
        }
    ],
    currency: 'Kč',
    phonePrefix: '+420',
    infoline: "+420 241 170 000",
    phoneValidationHint: '+420 241 170 000',
    googleMapsOptions: {
        center: {
            lat: 49.9038546,
            lng: 15.6319456,
        },
        zoom: 8
    },
}

export const langInstances: LangInstanceConfigs = {
    sk: SkVersionDefaults,
    cz: CzVersionDefaults
}